// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uMa+M","isHalf":"styles_isHalf__1Q2QK","buttonUpdate":"styles_buttonUpdate__mDvph","error":"styles_error__44NhA","success":"styles_success__e2+UJ"};